// extracted by mini-css-extract-plugin
export default {"banner":"Home_banner__I7Xt-","image":"Home_image__jsSxX","arrowRow":"Home_arrowRow__+yGED","arrow":"Home_arrow__mBKBk"};